import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { faArrowRight, faGlobe } from "@fortawesome/free-solid-svg-icons";
import api, { getData } from "../services/api";
import {
  Button,
  EmptyState,
  ErrorState,
  PageHeader,
  Skeleton,
  StatusBadge,
} from "./UI";

export default function WebsiteSelector({ destination, title, description }) {
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, items: [], error: "" });
  useEffect(() => {
    api
      .get("/websites", {
        params: { limit: 100, sortBy: "name", sortOrder: "asc" },
      })
      .then((r) =>
        setState({ loading: false, items: getData(r).items, error: "" }),
      )
      .catch((e) => setState({ loading: false, items: [], error: e.message }));
  }, []);
  return (
    <>
      <PageHeader
        eyebrow="Tenant scope"
        title={title}
        description={description}
      />
      {state.loading ? (
        <Skeleton />
      ) : state.error ? (
        <ErrorState message={state.error} />
      ) : !state.items.length ? (
        <EmptyState
          icon={faGlobe}
          title="No websites yet"
          message="Create a website first to configure this area."
          action={
            <Button onClick={() => navigate("/websites")}>
              Go to websites
            </Button>
          }
        />
      ) : (
        <section className="selector-list">
          {state.items.map((site) => (
            <article key={site._id}>
              <div className="site-avatar">{site.name?.[0]}</div>
              <div>
                <h3>{site.name}</h3>
                <p>{site.domain}</p>
              </div>
              <StatusBadge active={site.status === "active"} />
              <Button
                variant="secondary"
                icon={faArrowRight}
                onClick={() => navigate(`/websites/${site._id}/${destination}`)}
              >
                Open
              </Button>
            </article>
          ))}
        </section>
      )}
    </>
  );
}
